import { Badge } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import { prettifyPhone } from '../../../../../utils/common/phones';
import { TableAction } from '../components/TableAction';
import { DATE_TIME_MINUTE } from '../../../../../shared/contants/date';

export const getColumns = () => [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: '66px',
        render: text => text,
    },
    {
        title: 'Имя',
        dataIndex: '',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: user => (
            <>
                {user?.is_blocked && (
                    <div>
                        <Badge status='warning' title='Заблокирован' />
                        <span style={{ marginLeft: 8 }}>{user.name}</span>
                    </div>
                )}
                {!user?.is_blocked && <>{user.name}</>}
            </>
        ),
    },
    {
        title: 'Юзернейм',
        dataIndex: 'telegram_user_name',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: names => names,
    },
    {
        title: 'Почта',
        dataIndex: 'email',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: text => text,
    },
    {
        title: 'Телефон',
        dataIndex: 'phone',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: (text: number | null) =>
            text ? prettifyPhone(text.toString()) : '',
    },
    {
        title: 'Регистрация',
        dataIndex: 'created_at',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: time => dayjs(time).format('DD.MM.YY HH:mm'),
    },
    {
        title: 'Сообществ',
        dataIndex: 'community_owner_num',
        key: 'id',
        width: '89px',
        ellipsis: true,
        render: text => text || 0,
    },
    {
        title: 'Последняя активность',
        dataIndex: 'updated_at',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: text => dayjs(text).format(DATE_TIME_MINUTE),
    },
    {
        title: 'Сумма поступлений',
        dataIndex: 'payins',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: text => text,
    },
    {
        title: 'Комиссия',
        dataIndex: 'commission',
        key: 'id',
        width: '89px',
        ellipsis: true,
        render: text => text + '%' || 0,
    },
    {
        title: 'Действие',
        dataIndex: '',
        key: 'id',
        width: '110px',
        ellipsis: true,
        render: user => <TableAction user={user} />,
    },
];
